import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DirectEntityModule } from "./direct-entity/direct-entity.module";
import { ExternalEntityModule } from "./external-entity/external-entity.module";

const routes:Routes=[
    {
        path: 'direct-entity',
        data: {
            title: 'Direct Entity'
        },
        loadChildren:() => DirectEntityModule 
    },
    {
        path: 'entity',
        data: {
            title: 'Entity'
        },
        loadChildren:() => ExternalEntityModule 
    }
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class PeoplesRoutingModule
{

}